export default __webpack_public_path__ + "static/media/img_1.2e3bf3ff.png";